import {
  ExamCenterDetails,
  ExamCenterDetailsPermissionRoute,
} from '@exam-center/exam-center-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { WithPermission } from '@shared/permissions';

export default function ExamCenterDetailsPage() {
  const { examCenterCode } = useParams('/:examCenterCode/details');

  return (
    <WithPermission
      requiredPermission={APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW}
      errorElement={ExamCenterDetailsPermissionRoute}
      slotProps={{ errorElement: { examCenterCode } }}
    >
      <ExamCenterDetails />
    </WithPermission>
  );
}
